<template>
  <sf-dialog
    :model-value="modelValue"
    :width="width"
    scrollable
    @update:model-value="emit('update:modelValue', $event)"
  >
    <v-card class="d-flex flex-column">
      <v-card-title class="d-flex align-center justify-space-between">
        <span>{{ title }}</span>

        <v-btn icon variant="text" @click="emit('update:modelValue', false)">
          <v-icon :icon="mdiClose" />
        </v-btn>
      </v-card-title>

      <v-divider />

      <slot name="header" />

      <v-card-text class="product-content-dialog__content" :class="contentClass">
        <slot />
      </v-card-text>
    </v-card>
  </sf-dialog>
</template>

<script setup lang="ts">
import SfDialog from '@/components/dialog/SfDialog.vue'
import { mdiClose } from '@mdi/js'

defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  width: {
    type: Number,
    default: 1100
  },
  contentClass: {
    type: String,
    default: 'pa-4 d-flex flex-column'
  }
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()
</script>

<style scoped>
.product-content-dialog__content {
  height: min(70vh, calc(100dvh - 180px));
  min-height: 260px;
  max-height: 1200px;
  overflow-y: auto;
}
</style>
